// extracted by mini-css-extract-plugin
export default {"content":"page_content__E9oqx","button-content":"page_button-content__66Ic4"};